import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  PULSE_CLICK_ACTION,
  resolveProductSizeClickLabel,
  trackProductPageClick,
} from '../../analytics/pulseClickIds';
import { useProductPageViewPrice } from '../../analytics/useProductPageViewPrice';
import { Spinner } from 'react-bootstrap';
import * as CONSTANT from '../../constants';
import {
  availableForSelectedOrderType,
  unavailableModifiersList,
  verifyStatus,
} from '../../helpers/customizedItem/customizedItem.helper';
import { getCustomizedItemCalories } from '../../helpers/getCombineCalories/getCombineCalories.helper';
import {
  creatingModifiersForItems,
  isItCreateYourOwnItem,
  itemSize,
  scrollToElementByRef,
  showMakeItTryToCombo,
} from '../../helpers/helperMethods';
import { itemBuckets } from '../../priceCalculation/buckets';
import { calculatePriceForItem } from '../../priceCalculation/calculatePrice';
import { getItemTotal, toFixedNumber } from '../../priceCalculation/helper';
import {
  sizeSelection,
  updatePriceForItem,
  updateTry2ComboSelectedModifiers,
} from '../../redux/slices/itemCustomizationSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/store';
import ComplementaryItems from '../../containers/try2/subComponents/ComplementaryItems';
import ItemDetail from './ItemCustomization/ItemDetail';
import MakeItTryTwoCombo from './ItemCustomization/MakeItTryTwoCombo';
import RequiredModifiers from './ItemCustomization/RequiredModifiers';
import ItemSizeCard from './ItemCustomization/SizeCard';
import CustomizeButton from './Buttons/customizeButton';
import FavoriteButton from '../../containers/try2/Customization/FavoriteButton';
import useFavorites from '../../react-query-hooks/useFavorites';
import { useAuthState } from '../../context/UserAuthentication';
import useRemoveFavorite from '../../react-query-hooks/Favorites/useRemoveFavorite';
import useAddFavorites from '../../react-query-hooks/Favorites/useAddFavorite';
import { IAddToCartPayload } from '../../models/order';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import ItemsBox from './SelectedItems/ItemsBox';
import Button from '../Buttons/Button';
import { Codes } from '../../models/item.model';
import _debounce from 'lodash/debounce';
import useIsInViewport from '../../hooks/useVisibility';
import { OrderNameForm } from './OrderNameForm/OrderNameForm';
import _clonedeep from 'lodash.clonedeep';
import { HALF_SIZE } from '../../constants';
import { ISingleBucket } from '../../priceCalculation/priceCalculation';
import { IModifiersObjects } from '../../models/try2Combo';
import UpSellModifierGroup from './ItemCustomization/UpSellModifierGroup/UpSellModifierGroup';
import EventBusForBYOCategoryScrollingBetweenAccordions from '../../utils/EventBusForBYOCategoryScrollingBetweenAccordions';
import { useLocation } from 'react-router';
import { isUserAuthorizedForTestingPayload } from '../utils';
import { useIsDesignV2 } from '../../hooks/useIsDesignV2';

const SIZE_NOT_SELECTED = 'SIZE NOT SELECTED';
const REQUIREDMODIFIER_NOT_SELECTED = 'REQUIREDMODIFIER NOT SELECTED';
interface IItemOrder {
  item: any;
  styleClasses: { readonly [key: string]: string };
  order: any;
  handelRedeemSize: () => void;
  reward_size: string;
  handleScrollToCustomisation?: () => void;
  handleIngredientSelection: (data: any, id?: number) => void;
  unrepeatedIngredients: any[];
  setForceRender: (forceRender: boolean) => void;
  forceRender: boolean;
  handleSyncIngredients: (item: any) => void;
  showCustomization: boolean;
  redeemSize: any;
  setShowCustomizedOptions: (state: boolean) => void;
  showModifierModal: () => void;
  addToOrder: (structuredOrder: any, isCombo?: boolean) => Promise<boolean>;
  loading: boolean;
  showCustomizedOptions: boolean;
  getOrderButtonState: (type: any) => {
    status: boolean;
    missingGroupIndex?: number;
  };
  titleshow?: string;
  scrollOnSize?: () => void;
  setFirstTimeModal?: (value: boolean) => void;
  firstTimeModal?: boolean;
  addToOrderButtonShown: (state: boolean) => void;
  editItemQuantity: number;
  recipient_name: string;
  itemDetailReady?: boolean;
  isItemRedeemed: boolean;
  requiredModifiersAtItemDetailSectionToHandleScroll: {
    refToScrollToMissingRequiredModifiers: any[];
    isRequiredModifierSelected: {
      status: boolean;
      highLightArea: number;
    };
    setIsRequiredModifierSelected: React.Dispatch<
      React.SetStateAction<{ status: boolean; highLightArea: any }>
    >;
  };
  CYOIScrollToMissingRequiredArea?: {
    refToScrollToMissingRequiredArea: any[];
    isCYOIRequiredModifierSelected: {
      status: boolean;
      highLightArea: number;
    };
    setIsCYOIRequiredModifierSelected: React.Dispatch<
      React.SetStateAction<{ status: boolean; highLightArea: any }>
    >;
  };
  isItSandWichAndNotMultiSize?: any;
  isItemAvailable?: any;
  showMakeItTryToCombo?: any;
  dbId: string;
  isNavigatingToCombo?: MutableRefObject<boolean>;
  location_id: number
}

const ItemOrder: React.FC<IItemOrder> = (props) => {
  const {
    item,
    styleClasses,
    order,
    handelRedeemSize,
    reward_size,
    handleIngredientSelection,
    unrepeatedIngredients,
    setForceRender,
    forceRender,
    handleSyncIngredients,
    showCustomization,
    redeemSize,
    setShowCustomizedOptions,
    addToOrder,
    showModifierModal,
    showCustomizedOptions,
    getOrderButtonState,
    loading,
    scrollOnSize,
    setFirstTimeModal,
    firstTimeModal,
    addToOrderButtonShown,
    editItemQuantity,
    recipient_name,
    itemDetailReady = true,
    isItemRedeemed,
    requiredModifiersAtItemDetailSectionToHandleScroll,
    handleScrollToCustomisation,
    CYOIScrollToMissingRequiredArea,
    dbId,
    isNavigatingToCombo,
    location_id
  } = props;

  const location = useLocation();
  const isItMobile = useCheckMobileScreen();

  const isDesignV2 = useIsDesignV2();

  const [openFirstTimeModalWhenCartClose, setOpenFirstTimeModalWhenCartClose] =
    useState<boolean>(false);
  const Cart = useAppSelector((state) => state.cart);

  const dispatch = useAppDispatch();
  const { authInfo } = useAuthState();
  let { mutateAsync: removeFavorite } = useRemoveFavorite();
  let { mutateAsync: addFavorite } = useAddFavorites();

  const [quantity, setQuantity] = useState<number>(editItemQuantity ?? 1);
  const [madeForName, setMadeForName] = useState<string>(recipient_name ?? '');
  const [isSize, setIsSize] = useState(false);
  const [
    enableOtherRequiredByDefaultSelectionAndSizeClickAction,
    setEnableOtherRequiredByDefaultSelectionAndSizeClickAction,
  ] = useState<boolean>(false);
  const selectSizeScrollRef = useRef(null);
  const [startScrollingForMobile, setStartScrollingForMobile] = useState<{
    status: boolean;
    orderButtonStatus: any;
    updateStateFor: typeof CONSTANT.CREATE_YOUR_OWN_ITEM | null;
  }>({
    status: false,
    orderButtonStatus: null,
    updateStateFor: null,
  });

  const { data: favorites = [] } = useFavorites(authInfo.userId, authInfo.type, location_id);

  const [favoriteItems, setFavoriteItems] = useState<any>({});

  const checkSizeSelection = () => {
    if (
      (order?.size && item?.half_brink_item_id) ||
      (!order?.size && !item?.half_brink_item_id) ||
      (showCustomization && order?.size && !item?.half_brink_item_id)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const startScrollingToMissingRequiredModifiers = (orderButtonStatus) => {
    const {
      refToScrollToMissingRequiredModifiers,
      isRequiredModifierSelected,
      setIsRequiredModifierSelected,
    } = requiredModifiersAtItemDetailSectionToHandleScroll;
    setIsRequiredModifierSelected({
      status: orderButtonStatus.status,
      highLightArea: orderButtonStatus.missingGroupIndex,
    });
    setTimeout(() => {
      setIsRequiredModifierSelected({
        status: false,
        highLightArea: null,
      });
    }, 2000);
    for (let i = 0; i < refToScrollToMissingRequiredModifiers.length; i++) {
      if (i === orderButtonStatus.missingGroupIndex) {
        refToScrollToMissingRequiredModifiers[i].current?.scrollIntoView({
          behavior: 'smooth',
          block: `${isItMobile ? 'center' : 'center'}`,
        });
        break;
      }
    }
  };

  const startScrollingToMissingCYOIRequiredModifiers = (orderButtonStatus) => {
    const {
      refToScrollToMissingRequiredArea,
      setIsCYOIRequiredModifierSelected,
    } = CYOIScrollToMissingRequiredArea;
    setIsCYOIRequiredModifierSelected({
      status: orderButtonStatus.status,
      highLightArea: orderButtonStatus.missingGroupIndex,
    });
    EventBusForBYOCategoryScrollingBetweenAccordions.emit(
      'updateMissingRequiredRefCurrentMissingIndex',
      orderButtonStatus.missingGroupIndex
    );
    EventBusForBYOCategoryScrollingBetweenAccordions.emit(
      'refUpdatedForBuildYourOwnRequiredScrollOnAddOnsAccorionClick',
      EventBusForBYOCategoryScrollingBetweenAccordions.getState()
    );
    setTimeout(() => {
      setIsCYOIRequiredModifierSelected({
        status: false,
        highLightArea: null,
      });
    }, 2000);
    for (let i = 0; i < refToScrollToMissingRequiredArea.length; i++) {
      if (i === orderButtonStatus.missingGroupIndex) {
        refToScrollToMissingRequiredArea[i].current?.scrollIntoView({
          behavior: 'smooth',
          block: `${isItMobile ? 'start' : 'center'}`,
        });
        break;
      }
    }
  };

  const updateStateForNotSelectedSection = (
    type: typeof SIZE_NOT_SELECTED | typeof REQUIREDMODIFIER_NOT_SELECTED
  ) => {
    switch (type) {
      case SIZE_NOT_SELECTED:
        {
          scrollToElementByRef(selectSizeScrollRef, isItMobile ? -200 : -420);
          setIsSize(true);
          setTimeout(() => {
            setIsSize(false);
          }, 2000);
        }
        break;
      default: {
      }
    }
  };

  const checkIfAllRequiedSelected = (
    SelectedRequiredModifier
  ): { status: boolean; missingGroupIndex: number } => {
    let minReached = null;
    const result: { status: boolean; missingGroupIndex: number } = {
      status: true,
      missingGroupIndex: null,
    };
    for (
      let index = 0;
      index < item.items_required_modifier_groups.length;
      index++
    ) {
      const isModifierExistFromCurrentGroup =
        SelectedRequiredModifier.additionalAdded.modifiers.filter(
          (modifier) =>
            modifier.modifier_group_id ===
            item.items_required_modifier_groups[index].id
        );
      const isNoDressingSelectedForCurrentGroup = SelectedRequiredModifier?.noDressings?.find(
          (modGroup) =>
            modGroup.id === item.items_required_modifier_groups[index].id &&
            modGroup.noDressing
        );
        minReached =
        isModifierExistFromCurrentGroup.length >=
        item.items_required_modifier_groups[index].min;
      if (
        (!isModifierExistFromCurrentGroup.length && !isNoDressingSelectedForCurrentGroup) || (
        !minReached &&
        !isNoDressingSelectedForCurrentGroup
      )
      ) {
        result.status = false;
        result.missingGroupIndex = index;
        break;
      }
    }
    return result;
  };

  useEffect(() => {
    if (
      !item.half_brink_item_id &&
      item.items_required_modifier_groups.length === 1 &&
      item.items_modifier_groups.length === 0 &&
      item.core_modifiers.length === 0 &&
      item.items_required_modifier_groups[0].extendable_limit === 1 &&
      item.items_required_modifier_groups[0].max === 1 &&
      item.items_required_modifier_groups[0].min === 1 && !Cart.showCart){
        setEnableOtherRequiredByDefaultSelectionAndSizeClickAction(true);
        return;
      }
    if (!isCreateYourOwnItem) return;
    const checkForMisssingRequiredModifierGroups = () => {
      const requiredModifierSelection: {
        status: boolean;
        missingGroupIndex?: number;
      } = getOrderButtonState(CONSTANT.ADD_TO_ORDER);
      return requiredModifierSelection;
    };
    EventBusForBYOCategoryScrollingBetweenAccordions.subscribe(
      'checkForMissingRequiredModifers',
      checkForMisssingRequiredModifierGroups
    );
    return () => {
      if (!isCreateYourOwnItem) return;
      EventBusForBYOCategoryScrollingBetweenAccordions.unsubscribe(
        'checkForMissingRequiredModifers',
        checkForMisssingRequiredModifierGroups
      );
    };
  }, []);

  const onCustomizeClick = (type: string): boolean => {
    const requiredModifiersBucket: ISingleBucket = itemBuckets.getSingleBucket({
      name: CONSTANT.REQUIRED_MODIFIERS,
      fromItem: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });
    const sizeSelection = checkSizeSelection();
    const requiredModifierSelection: {
      status: boolean;
      missingGroupIndex: number;
    } = checkIfAllRequiedSelected(requiredModifiersBucket);

    if (sizeSelection && requiredModifierSelection.status) {
      if (type === CONSTANT.CUSTOMIZE && handleScrollToCustomisation) {
        handleScrollToCustomisation();
      }
      return false;
    }
    if (!requiredModifierSelection.status) {
      startScrollingToMissingRequiredModifiers(requiredModifierSelection);
    }
    if (!sizeSelection) {
      updateStateForNotSelectedSection(SIZE_NOT_SELECTED);
    }
    return true;
  };

  useEffect(() => {
    if (showModifierModal && startScrollingForMobile.status) {
      if (
        startScrollingForMobile.updateStateFor === CONSTANT.CREATE_YOUR_OWN_ITEM
      ) {
        startScrollingToMissingCYOIRequiredModifiers(
          startScrollingForMobile.orderButtonStatus
        );
        setStartScrollingForMobile({
          status: false,
          orderButtonStatus: null,
          updateStateFor: null,
        });
      }
    }
  }, [startScrollingForMobile]);

  useEffect(() => {
    if (favorites.length > 0) {
      const favouriteItem = favorites?.find((fvrt) => fvrt.item_id === item.id);
      setFavoriteItems(favouriteItem ? favouriteItem : {});
    }
  }, [favorites]);

  const removeFavoriteItem = (favoriteItemId: any, item: any) => {
    const userId = authInfo.userId;
    removeFavorite(
      { itemId: favoriteItemId, userId },
      {
        onError: (error, variables, context) => {
          setFavoriteItems(item);
        },
      }
    );
  };

  const addFavoriteItem = (item: any) => {
    addFavorite(
      { ...item, customer_id: authInfo.userId },
      {
        onError: (error, variables, context) => {
          setFavoriteItems({});
        },
      }
    );
  };

  const debouncedAddFavourite = useCallback(
    _debounce(addFavoriteItem, 500),
    []
  );
  const debouncedRemoveFavourite = useCallback(
    _debounce(removeFavoriteItem, 500),
    []
  );

  const favoriteButtonHandler = (
    e: React.MouseEvent<HTMLButtonElement>,
    item
  ) => {
    if (Object.keys(favoriteItems)?.length <= 0) {
      setFavoriteItems(item);
      debouncedAddFavourite(item);
    } else {
      setFavoriteItems({});
      debouncedRemoveFavourite(item?.id, item);
    }
  };

  const isCreateYourOwnItem = isItCreateYourOwnItem(item?.is_create_your_own);

  const CustomizeButtonShow = () => {
    if (isCreateYourOwnItem || !item?.is_customizable) {
      return false;
    } else {
      return true;
    }
  };

  const unavailableModifiers = unavailableModifiersList(item);
  const renderCustomizeButton =
    item && item.items_modifier_groups?.length && item.core_modifiers?.length;
  const showCustomizeButton = CustomizeButtonShow();
  const orderedIngredients = order?.modifiers[0]?.modifiers;
  const cart = useAppSelector((state) => state.cart);
  const isOrderTypeSelected = cart?.isOrderTypeSelected;
  const savedOrderType = cart?.orderType;

  const handleCustomizationModal = () => {
    if (isItMobile) showModifierModal();
    if (!isItMobile) {
      if (order.size) {
        setShowCustomizedOptions(true);
        scrollOnSize();
      } else {
        showModifierModal();
        setFirstTimeModal(true);
      }
    }
  };

  const handleSizeForCustomization = (size: string) => {
    let obj = {
      size: size,
      ...(size === CONSTANT.FULL_SIZE.id && {
        brink_id: item.full_brink_item_id,
      }),
      ...(size === CONSTANT.HALF_SIZE.id && {
        brink_id: item.half_brink_item_id,
      }),
    };
    trackProductPageClick({
      action: PULSE_CLICK_ACTION.SELECT_CUSTOM_OPTION,
      label: resolveProductSizeClickLabel(
        size,
        item?.category_name,
        item?.category_id
      ),
    });
    dispatch(sizeSelection(obj));
  };
  const handleModalContentOnSizeSelection = () => {
    if (
      item.items_required_modifier_groups.length === 1 &&
      item.items_modifier_groups.length === 0 &&
      item.core_modifiers.length === 0 &&
      item.items_required_modifier_groups[0].extendable_limit === 1 &&
      item.items_required_modifier_groups[0].max === 1 &&
      item.items_required_modifier_groups[0].min === 1 && itemBuckets.specificItemBucketSelectedModifiers(
        CONSTANT.REQUIRED_MODIFIERS,
        CONSTANT.SINGLE_ITEM_SELECTED_SECTION.toString()
      ).length < 1
    ) {
      setEnableOtherRequiredByDefaultSelectionAndSizeClickAction(true);
    }
  }
  // Handler for managing state of current selected size
  const handleItemSizeChange = (e: React.ChangeEvent<HTMLInputElement>, onClickClicked = false) => {
    handleModalContentOnSizeSelection();
    if(onClickClicked) return;
    if (isCreateYourOwnItem) handleCustomizationModal();
    handleSizeForCustomization(e.target.id);
  };

  useEffect(() => {
    if (reward_size && item.half_brink_item_id) {
      handleModalContentOnSizeSelection();
      if (isCreateYourOwnItem) handleCustomizationModal();
      handleSizeForCustomization(reward_size);
    }
  }, [reward_size]);

  useEffect(() => {
    if (
      !dbId &&
      !item.half_brink_item_id &&
      isCreateYourOwnItem &&
      Cart.showCart
    ) {
      setOpenFirstTimeModalWhenCartClose(true);
    } else if (!dbId && !item.half_brink_item_id && isCreateYourOwnItem) {
      handleCustomizationModal();
    }
  }, [item]);

  useEffect(() => {
    if (!Cart.showCart && openFirstTimeModalWhenCartClose) {
      handleCustomizationModal();
      setOpenFirstTimeModalWhenCartClose(false);
    }
  }, [Cart.showCart]);

  const calculateItemPrice = (size: string, additionalPrice: number) => {
    let price = null;
    if (size === CONSTANT.HALF_SIZE.id) {
      price = toFixedNumber(
        additionalPrice +
          getItemTotal(
            item,
            order,
            item?.half_brink_item_price,
            CONSTANT.HALF_SIZE.id
          )
      );
    } else {
      price = toFixedNumber(
        additionalPrice +
          getItemTotal(item, order, item?.price, CONSTANT.FULL_SIZE.id)
      );
    }
    return price;
  };

  const getItemRedeemPoints = (order: any, size: string) => {
    return size === HALF_SIZE.id
      ? order.half_loyalty_points
      : order.full_loyalty_points;
  };

  const generateOrderStructure = (currentOrder, quantity?) => {
    const itemObject = _clonedeep(currentOrder?.modifiers);
    const itemWithComplmentaryModifiers = creatingModifiersForItems(
      itemObject,
      1
    );
    const structuredOrder: IAddToCartPayload = {
      item_id: currentOrder?.item_id,
      display_price: parseFloat(
        calculateItemPrice(currentOrder?.size, currentOrder?.display_price)
      ),
      item_size: itemSize(currentOrder?.size, item?.half_brink_item_id),
      name: currentOrder?.name,
      modifiers: [],
      item_calories: currentOrder?.item_calories,
      category_name: item?.category_name,
      category_id: item?.category_id,
      make_time_minutes: item?.make_time_minutes,
      redeem_points: getItemRedeemPoints(item, currentOrder?.size),
      recipient_name: madeForName,
    };
    itemWithComplmentaryModifiers?.map((currentObject, index: number) => {
      if (currentObject?.item) {
        structuredOrder?.modifiers.push.apply(
          structuredOrder?.modifiers,
          currentObject?.modifiers
        );
      } else {
        structuredOrder?.modifiers.push(currentObject);
      }
    });

    if (quantity) structuredOrder.quantity = quantity;

    // BELOW CODE IS FOR ADDING NO DRESSING IN MODIFIERS DON"T REMOVE

    const selectedModifier = itemBuckets.getSingleBucket({
      name: CONSTANT.REQUIRED_MODIFIERS,
      fromItem: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });

    if (selectedModifier?.noDressings) {
      selectedModifier?.noDressings.forEach((dressingItem) => {
        if (dressingItem?.noDressing) {
          const noDressItem = item?.items_required_modifier_groups.find(
            (e) => e?.id === dressingItem.id
          );
          const payload = {
            modifier_id: 0,
            modifier_name: noDressItem?.no_modifier_label,
            modifier_label: `No ${noDressItem?.no_modifier_label}`,
            display_price: 0,
            modifier_calories: 0,
            brink_id: 0,
            quantity: 0,
            modifier_group_min: 0,
            max: 0,
            type: CONSTANT.SELECTED,
            code: Codes.NO,
            extendableLimitValue: 0,
            modifier_group_id: noDressItem?.id,
            modifier_group_max: noDressItem?.max,
            in_item: 0,
            in_slide: false,
            modifier_type: CONSTANT.REQUIRED_MODIFIERS,
            additionalPrice: 0,
            is_no_modifier_selected: 1,
          };
          structuredOrder.modifiers.push(payload);
        }
      });
    }
    return structuredOrder;
  };

  const getItemTotalCalories = (calories) => {
    let cal = getCustomizedItemCalories(order, calories, item?.is_selected);
    return cal;
  };

  const addToOrderHandler = () => {
    if (!showCustomization) {
      trackProductPageClick({
        action: PULSE_CLICK_ACTION.TAP_ADD_TO_CART,
        label: item?.name ?? null,
      });
    }
    if (!isCreateYourOwnItem) {
      const isNotDisabled = onCustomizeClick(CONSTANT.ADD_TO_ORDER);
      if (isNotDisabled) return;
    }
    const orderButtonStatus = getOrderButtonState(CONSTANT.ADD_TO_ORDER);
    if (orderButtonStatus.status) {
      if (isCreateYourOwnItem) {
        if (isItMobile) {
          showModifierModal();
          setStartScrollingForMobile({
            status: true,
            orderButtonStatus,
            updateStateFor: CONSTANT.CREATE_YOUR_OWN_ITEM,
          });
        } else {
          startScrollingToMissingCYOIRequiredModifiers(orderButtonStatus);
        }
      }
      return;
    }

    addToOrder(generateOrderStructure(order, quantity));
  };

  const handleMakeItComboValidation = (): boolean => {
    if (!isCreateYourOwnItem) {
      const isNotDisabled = onCustomizeClick(CONSTANT.MAKE_IT_A_TRY_2_COMBO);
      if (isNotDisabled) return false; // Validation failed
    }
    const orderButtonStatus = getOrderButtonState(CONSTANT.MAKE_IT_A_TRY_2_COMBO);
    if (isCreateYourOwnItem && orderButtonStatus.status) {
      if (isItMobile) {
        showModifierModal();
        setStartScrollingForMobile({
          status: true,
          orderButtonStatus,
          updateStateFor: CONSTANT.CREATE_YOUR_OWN_ITEM,
        });
      } else {
        startScrollingToMissingCYOIRequiredModifiers(orderButtonStatus);
      }
      return false; // Validation failed
    }
    return true; // Validation passed
  };

  const availableForOrderType = () => {
    return (
      isOrderTypeSelected && availableForSelectedOrderType(item, savedOrderType)
    );
  };

  // Wrapper function for add complemantary
  const handleComplementaryIngredientSelection: (
    data: any,
    id?: 1 | 2 | 3 | 4
  ) => void = (
    data,
    id = CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_SINGLE_ITEM
  ) => {
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem({
      currentModifier: data,
      item_id: id,
    });
    dispatch(updateTry2ComboSelectedModifiers({ itemModifiers, itemId }));
    if (activeBucket !== undefined) {
      dispatch(updatePriceForItem({ itemId, activeBucket }));
    }
    setForceRender(!forceRender);
  };

  const price = () => {
    const price =
      getItemTotal(item, order, item.price, CONSTANT.LARGE_SIZE.id) +
      order?.display_price;
    return price.toFixed(2);
  };

  const showFavrtButton = () => {
    if (
      authInfo?.userId &&
      !isCreateYourOwnItem
    ) {
      return true;
    }
    return false;
  };
  const showFooterButtonRef = useRef(null);
  const showFooterButton = useIsInViewport(showFooterButtonRef);
  useEffect(() => {
    addToOrderButtonShown(showFooterButton);
  }, [showFooterButton]);

  const showRedBorderAnimation = (index) => {
    return requiredModifiersAtItemDetailSectionToHandleScroll
      ? !requiredModifiersAtItemDetailSectionToHandleScroll
          .isRequiredModifierSelected.status &&
          requiredModifiersAtItemDetailSectionToHandleScroll
            .isRequiredModifierSelected.highLightArea === index
      : false;
  };

  const getItemCurrentPrice = () => {
    let bothSizeAvailable = false;
    if(item.half_brink_item_id && item.full_brink_item_id) {
      bothSizeAvailable = true;
    }
    if(bothSizeAvailable) {
      return parseFloat(calculateItemPrice(order?.size, order?.display_price)).toFixed(2);
    }
    return price();
  }

  const buttonLabel = showCustomization ? 'UPDATE ORDER' : 'ADD TO ORDER';
  const isSizedItem = Boolean(item.half_brink_item_id && item.full_brink_item_id);
  const showPrice = !isSizedItem || Boolean(order.size);
  const buttonPrice = isSizedItem
    ? parseFloat(getItemCurrentPrice()).toFixed(2)
    : price();

  useProductPageViewPrice(
    isSizedItem ? (showPrice ? getItemCurrentPrice() : null) : price(),
    itemDetailReady,
    showPrice
  );

        // Inline styles for JSON-like display
  const jsonContainerStyle = {
    fontFamily: 'Consolas, Monaco, "Courier New", monospace',
    fontSize: '13px',
    backgroundColor: '#f6f8fa',
    border: '1px solid #d0d7de',
    borderRadius: '6px',
    padding: '6px 12px',
    lineHeight: '1.5',
    display: "flex",
    width: "fit-content",
    marginBottom: "16px"
  };

  const braceStyle = {
    color: '#24292f',
    fontWeight: 'bold',
  };

  const keyStyle = {
    color: '#0550ae',
    fontWeight: '600',
  };

  const valueStyle = {
    color: '#0a3069',
  };

  const punctuationStyle = {
    color: '#57606a',
  };
  
  return (
    <React.Fragment>
      {showFavrtButton() && (
        <FavoriteButton
          favIcon={true}
          buttonHandler={favoriteButtonHandler}
          className="d-none d-lg-block position-static ms-auto mb-2 mt-4"
          item={item}
          favourite={Object.keys(favoriteItems)?.length > 0 ? true : false}
          isIconblueFill={false}
        />
      )}
      <ItemDetail
        name={item?.name}
        item={item}
        description={item?.description}
        styleClasses={styleClasses}
        unAvailableModifiers={unavailableModifiers}
        tags={item?.tags}
        favoriteButtonHandler={favoriteButtonHandler}
        favourite={Object.keys(favoriteItems)?.length > 0 ? true : false}
        authInfo={authInfo}
      />
      {item.is_active && verifyStatus(item, "item_location") ? (
        <div
          className={`${
            styleClasses.selector_wrapper
          } pt-2 single-itemOrder-wrap
          ${
            isDesignV2
              ? showMakeItTryToCombo(item?.category_name) &&
                !showCustomization &&
                props.isItemAvailable() &&
                props.isItSandWichAndNotMultiSize() &&
                (order?.size == CONSTANT.HALF_SIZE.upper_case ||
                              !item.half_brink_item_id)
                ? styleClasses.selector_wrapper_with_try2combo
                : styleClasses.selector_wrapper_without_try2combo
              : "testing"
          }
          `}
        >
          {/* Select Size */}
          <div ref={selectSizeScrollRef}>
            {item.half_brink_item_id ? (
              <ItemSizeCard
                getItemTotalCalories={getItemTotalCalories}
                item={item}
                getItemTotal={getItemTotal}
                order={order}
                handleItemSizeChange={handleItemSizeChange}
                handleRedeemSize={handelRedeemSize}
                reward_size={reward_size}
                isSize={isSize}
                setIsSize={setIsSize}
              />
            ) : (
              <div>
                <h6 className="f-s18 text-start lh-normal" data-testid="priceTag">
                  Total: ${price()}
                </h6>
                <hr />
              </div>
            )}
          </div>

          {/* For Listing selected ingredients in create own salad */}
          {isCreateYourOwnItem && orderedIngredients?.length > 0 ? (
            <ItemsBox
              orderedIngredients={orderedIngredients}
              isItMobile={isItMobile}
              showModifierModal={showModifierModal}
              setFirstTimeModal={setFirstTimeModal}
            />
          ) : null}
          <div />
          <>
            {!isCreateYourOwnItem
              ? item.items_required_modifier_groups.map((group, i: number) => (
                  <div key={i}>
                    <div
                      className={`${styleClasses.select_size_box} pt-0 pt-md-2`}
                    >
                      <h5
                        className="d-flex align-items-center justify-content-between f-sm-s18 f-s20 mb-2 mb-md-3 lh-normal font-Cls text-capitalize"
                        ref={
                          requiredModifiersAtItemDetailSectionToHandleScroll
                            ? requiredModifiersAtItemDetailSectionToHandleScroll
                                .refToScrollToMissingRequiredModifiers[i]
                            : null
                        }
                      >
                        Choose Your {group.label || group.name}
                        {/* <span className="caption fs-14">Required</span> */}
                      </h5>
                              {isUserAuthorizedForTestingPayload() && (
                                <span style={jsonContainerStyle}>
                                  <span style={braceStyle}>{"{ "}</span>
                                  <span style={keyStyle}>base</span>
                                  <span style={punctuationStyle}>: </span>
                                  <span style={valueStyle}>{group?.base ?? 0}</span>
                                  <span style={punctuationStyle}>, </span>
                                  <span style={keyStyle}>max</span>
                                  <span style={punctuationStyle}>: </span>
                                  <span style={valueStyle}>{group?.max ?? 0}</span>
                                  <span style={punctuationStyle}>, </span>
                                  <span style={keyStyle}>min</span>
                                  <span style={punctuationStyle}>: </span>
                                  <span style={valueStyle}>{group?.min ?? 0}</span>
                                  <span style={punctuationStyle}>, </span>
                                  <span style={keyStyle}>extendable_limit</span>
                                  <span style={punctuationStyle}>: </span>
                                  <span style={valueStyle}>{group?.extendable_limit ?? 0}</span>
                                  <span style={braceStyle}>{" }"}</span>
                                </span>
                              )}
                    </div>
                    <div
                      className={`${styleClasses.items_selector} d-flex select_size_box_dressing`}
                    >
                      <RequiredModifiers
                        requiredModifierGroup={group}
                        handleIngredientSelection={handleIngredientSelection}
                        showRedBorderAnimation={showRedBorderAnimation(i)}
                        enableOtherRequiredByDefaultSelectionAndSizeClickAction={
                          enableOtherRequiredByDefaultSelectionAndSizeClickAction
                        }
                        setEnableOtherRequiredByDefaultSelectionAndSizeClickAction={
                          setEnableOtherRequiredByDefaultSelectionAndSizeClickAction
                        }
                        addToOrderHandler={addToOrderHandler}
                        dbId={dbId}
                        price={buttonPrice}
                      />
                    </div>
                  </div>
                ))
              : null}
            {[
              CONSTANT.REACT_APP_BOWLS_ID,
              CONSTANT.REACT_APP_SALADS_ID,
            ].includes(item?.category_id?.toString()) ? (
              <UpSellModifierGroup
                coreModifiers={item?.core_modifiers}
                handleIngredientSelection={(data: IModifiersObjects) =>
                  handleIngredientSelection(
                    data,
                    CONSTANT.SINGLE_ITEM_SELECTED_SECTION
                  )
                }
                modifierGroups={item?.items_modifier_groups}
                required_modifiers_groups={item?.items_required_modifier_groups}
                category_name={item?.category_name}
                category_id={item?.category_id}
              />
            ) : null}
            <ComplementaryItems
              itemFromApi={item}
              unrepeatedIngredients={unrepeatedIngredients}
              handleIngredientSelection={handleComplementaryIngredientSelection}
              order={order}
              itemNo={2}
              isItEdit={showCustomization}
              isSingleItemCustomization={true}
              titleshow={`${styleClasses.asd} pt-5`}
            />
          </>
          <div>
            <OrderNameForm
              setQuantity={(quantity: number) => setQuantity(quantity)}
              isRedeemedItem={isItemRedeemed || !!reward_size}
              quantity={quantity}
              madeFor={madeForName}
              setMadeForName={(name: string) => setMadeForName(name)}
              itemId={item?.id}
              itemName={item?.name}
            />
          </div>

          {!isDesignV2 && (
            <div
              className={`${
                (!showMakeItTryToCombo(item?.category_name) ||
                  showCustomization) &&
              'flex-column'
              } single-item-btn-wrap d-flex align-items-center`}
              ref={showFooterButtonRef}
            data-testid='div-add-to-order'
            >
              {props.isItemAvailable() ? (
                <Button
                  type="button"
                  className={`mw-100 btn-disabled-bg add-to-order-right btn-large`}
                  id={
                    !showCustomization
                    ? 'add-to-order-button'
                    : 'update-order-button'
                  }
                  onClick={addToOrderHandler}
                  loading={loading}
                  LoaderPosition={showPrice ? "d-none" : "loader-position"}
                >
                  <span className="btn-inner-wrap">
                    <span>{buttonLabel}</span>
                    {showPrice && (
                      <span className="btn-price-loader-slot">
                        <span style={{ visibility: loading ? 'hidden' : 'visible' }}>{`$${buttonPrice}`}</span>
                        {loading && <Spinner animation="border" size="sm" className="btn-price-spinner" />}
                      </span>
                    )}
                  </span>
                </Button>
              ) : (
                <Button
                  type="button"
                  className={`mw-100 btn-disabled-bg add-to-order-right`}
                  disabled={true}
                  onClick={addToOrderHandler}
                  loading={loading}
                  LoaderPosition={`loader-position`}
                >
                  Unavailable
                </Button>
              )}

              {showCustomizeButton && props.isItemAvailable() ? (
                <CustomizeButton
                  item={item}
                  handleSyncIngredients={handleSyncIngredients}
                  setShowCustomizedOptions={setShowCustomizedOptions}
                  getOrderButtonState={(type: string) => onCustomizeClick(type)}
                  showModifierModal={showModifierModal}
                />
              ) : null}
            </div>
          )}
          {showMakeItTryToCombo(item?.category_name) &&
          !showCustomization &&
          props.isItemAvailable() &&
          props.isItSandWichAndNotMultiSize() &&
          !isDesignV2 ? (
            <div>
              <MakeItTryTwoCombo
                handleSyncIngredients={handleSyncIngredients}
                item={item}
                order={order}
                getOrderButtonState={getOrderButtonState}
                handleIngredientSelection={handleIngredientSelection}
                showCustomizedOptions={showCustomizedOptions}
                showCustomization={showCustomization}
                stickyAddToCartStyle={false}
                isNavigatingToCombo={isNavigatingToCombo}
                handleMakeItComboValidation={handleMakeItComboValidation}
              />
            </div>
          ) : null}
        </div>
      ) : (
        <button
          type="button"
          className="btn btn-large w-100 mx-auto mb-2"
          disabled={true}
        >
          Unavailable
        </button>
      )}
      <div
        className={` ${
          isCreateYourOwnItem ? 'gap-2' : `flex-wrap ${isDesignV2 ? "gap-0" : "gap-3"}`
        } sticky-add-to-cart d-flex justify-content-center px-3`}
      >
        <div
          className={`${isDesignV2 && !isCreateYourOwnItem && 'sticky-btn-wrap-design-v2'} ${
            isCreateYourOwnItem
              ? 'salad-sticky-btn'
              : 'sticky-btn-wrap justify-content-center'
          } d-flex single-item-btn-wrap mb-0 w-100 ${!showCustomizeButton && "only-add-to-order-button"}`}
        >
          {props.isItemAvailable() ? (
            <Button
              type="button"
              className={`mw-100 btn-disabled-bg add-to-order-right createSaladOrderBtn ${!!isDesignV2 && "f-sm-s16"}`}
              onClick={addToOrderHandler}
              loading={loading}
              LoaderPosition={showPrice ? "d-none" : "loader-position"}
              id={
                !showCustomization
                  ? "add-to-order-button"
                  : "update-order-button"
              }
            >
              <span className="btn-inner-wrap">
                <span>{buttonLabel}</span>
                {showPrice && (
                  <span className="btn-price-loader-slot">
                    <span style={{ visibility: loading ? 'hidden' : 'visible' }}>{`$${buttonPrice}`}</span>
                    {loading && <Spinner animation="border" size="sm" className="btn-price-spinner" />}
                  </span>
                )}
              </span>
            </Button>
          ) : (
            <Button
              type="button"
              className={`mw-100 btn-disabled-bg add-to-order-right createSaladOrderBtn ${!!isDesignV2 && "f-sm-s16"}`}
              disabled={true}
              onClick={addToOrderHandler}
              loading={loading}
              LoaderPosition={`loader-position`}
              id={
                !showCustomization
                  ? 'add-to-order-button'
                  : 'update-order-button'
              }
            >
              {'Unavailable'}
            </Button>
          )}
          {/* <div className='single-item-btn-wrap'> */}
          {showCustomizeButton && props.isItemAvailable() ? (
            <CustomizeButton
              item={item}
              handleSyncIngredients={handleSyncIngredients}
              setShowCustomizedOptions={setShowCustomizedOptions}
              getOrderButtonState={(type: string) => onCustomizeClick(type)}
              showModifierModal={showModifierModal}
            />
          ) : null}

          {/* </div> */}
        </div>
        {showMakeItTryToCombo(item?.category_name) &&
        !showCustomization &&
        props.isItemAvailable() &&
        props.isItSandWichAndNotMultiSize() ? (
          <div className={`${isDesignV2 && "pt-3"} ${isCreateYourOwnItem ? 'saladCombo' : `combo ${isItMobile && 'w-100'}`} `}>
            <MakeItTryTwoCombo
              handleSyncIngredients={handleSyncIngredients}
              item={item}
              order={order}
              getOrderButtonState={getOrderButtonState}
              handleIngredientSelection={handleIngredientSelection}
              showCustomizedOptions={showCustomizedOptions}
              showCustomization={showCustomization}
              stickyAddToCartStyle={true}
              isNavigatingToCombo={isNavigatingToCombo}
              handleMakeItComboValidation={handleMakeItComboValidation}
            />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default ItemOrder;
